export default "__VITE_ASSET__Cm1ynasQ__"